import React from "react";

function Footer() {
  return (
    <div className="footer">
      <a href="/privacy_policy">Privacy Policy</a>
      <a href="/terms_and_conditions">Terms and Conditions</a>
      <a href="/support">Support</a>
    </div>
  );
}

export default Footer;
